/**
 * @generated SignedSource<<5caaeb3d7a2abacd9e79298894db9cbd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalDetailScreenArchiveMutation$variables = {
  signalWorkspaceId: string;
};
export type WorkspaceSignalDetailScreenArchiveMutation$data = {
  readonly signalWorkspace: {
    readonly archive: {
      readonly archivedAtDate: {
        readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
      } | null;
      readonly id: string;
    };
  };
};
export type WorkspaceSignalDetailScreenArchiveMutation = {
  response: WorkspaceSignalDetailScreenArchiveMutation$data;
  variables: WorkspaceSignalDetailScreenArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "signalWorkspaceId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "signalWorkspaceId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceSignalDetailScreenArchiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "archive",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "archivedAtDate",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FormattedDate"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceSignalDetailScreenArchiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "archive",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "archivedAtDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9216a2046464910b7013135ea2a5ff4d",
    "id": null,
    "metadata": {},
    "name": "WorkspaceSignalDetailScreenArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceSignalDetailScreenArchiveMutation(\n  $signalWorkspaceId: ID!\n) {\n  signalWorkspace(id: $signalWorkspaceId) {\n    archive {\n      id\n      archivedAtDate {\n        ...FormattedDate\n      }\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "2a3bd3ee3a93369a6b449766b4ff21ff";

export default node;
